module.exports = __webpack_public_path__ + "img/hr-straight-rail-vertical-stone-path-remnants.295d08f1.png";